import { render, staticRenderFns } from "./ModelView.vue?vue&type=template&id=b03e9c94&scoped=true"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"
import style0 from "./ModelView.vue?vue&type=style&index=0&id=b03e9c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03e9c94",
  null
  
)

export default component.exports